<template>
  <div id="bon-date-select">

  <div id="bon-date-select-buttons">
    <v-btn class="text-transform-none bon-date-select-button"
      @click="setDayToday" :color="getColorToday"
      large>Сегодня</v-btn>

    <v-btn class="bon-date-select-button"
      @click="setDayYesterday" :color="getColorYesterday"
      large>Вчера</v-btn>

    <v-btn class="bon-date-select-button"
      @click="setDayOther" :color="getColorOther"
      large>{{ otherDayTitle }}</v-btn>
  </div>

  <v-expand-transition>
    <div id="bon-date-select-calendar" v-show="isPickerVisible" >
     <v-date-picker
        :full-width="true"
        v-model="resultDate"
        :first-day-of-week="1"
        locale="ru-RU"
        @change="emitToParent"
      ></v-date-picker>
    </div>
  </v-expand-transition>

  </div>
</template>


<script>

import moment from 'moment';

export default {

  name: 'DateSelector',
  data: () => ({
    'resultDate': undefined,
    'isPickerVisible': false,
    'otherDayTitle': '',
  }),
  mounted() {
    // this.resultDate = this.today();
    this.resetOtherDayTitle();
    // console.log('TODAY:'+this.today());
  },
  methods: {
    today() {
      return moment().format('YYYY-MM-DD');
    },
    yesterday() {
      return moment().subtract(1, 'days').format('YYYY-MM-DD');
    },
    resetOtherDayTitle() {
      this.otherDayTitle = 'В другой день';
    },
    setDayToday() {
      this.resultDate = this.today();
      this.isPickerVisible = false;
      this.$emit('dateSelected', this.resultDate);
      this.resetOtherDayTitle();
    },
    setDayYesterday() {
      this.resultDate = this.yesterday();
      this.isPickerVisible = false;
      this.$emit('dateSelected', this.resultDate);
      this.resetOtherDayTitle();
    },
    setDayOther() {
      this.isPickerVisible = true;
    },
    emitToParent(event) {
      this.$emit('dateSelected', this.resultDate);
      moment.locale('ru-RU');
      this.otherDayTitle = moment(this.resultDate).format('DD MMMM, dddd');
      this.isPickerVisible = false;
    },
  },
  computed: {
    isTodaySelected() {
      return this.resultDate === this.today();
    },
    isYesterdaySelected() {
      return this.resultDate === this.yesterday();
    },
    isOtherSelected() {
      return (this.resultDate &&
        ! this.isTodaySelected && ! this.isYesterdaySelected );
    },
    getColorToday() {
      return (this.isTodaySelected ? 'red' : 'grey');
    },
    getColorYesterday() {
      return (this.isYesterdaySelected ? 'red' : 'grey');
    },
    getColorOther() {
      return (this.isOtherSelected ? 'red' : 'grey');
    },
  },
};
</script>

<style scoped>

#bon-date-select {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

#bon-date-select-buttons span .v-btn__content {
  text-transform: unset;
}

.bon-date-select-button {
  margin: 0.3rem;
  color: white;
}

#bon-date-select-calendar {
  margin-top: 2rem;
  margin-left: auto;
  margin-right: auto;
}

</style>
